// extracted by mini-css-extract-plugin
export var blogHeroSlide = "blogHeroSlide-module--blogHeroSlide--ff0ec";
export var buttons = "blogHeroSlide-module--buttons--6ae76";
export var controlsContainer = "blogHeroSlide-module--controlsContainer--195cb";
export var darkText = "blogHeroSlide-module--darkText--6135b";
export var fadeIn = "blogHeroSlide-module--fadeIn--863ad";
export var fullWidth = "blogHeroSlide-module--fullWidth--6cd97";
export var grid = "blogHeroSlide-module--grid--0ac26";
export var headline = "blogHeroSlide-module--headline--f8773";
export var image = "blogHeroSlide-module--image--9dc42";
export var imageColumn = "blogHeroSlide-module--imageColumn--3e7e5";
export var indicatorContainer = "blogHeroSlide-module--indicatorContainer--a1b31";
export var lightText = "blogHeroSlide-module--lightText--5a53e";
export var textColumn = "blogHeroSlide-module--textColumn--20c4d";